import { FaArrowRight } from "react-icons/fa";
import { useNavigateAndScroll } from "../../../hooks/useNavigateAndScroll";
import WhatsappLink from "../../../utils/WhatsappLink";

const BiSteps = () => {
  const navigateAndScroll = useNavigateAndScroll();

  return (
    <div className="bi-steps-layout">
      {/* MEJORA */}
      <section className="light-section">
        <div className="columna">
          <div className="bi-step-content">
            <span className="bi-header">
              <img
                //   style={{ width: "20%" }}
                alt="numero-1"
                src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/numeros-1.png`}
              />
              <p>Mejora</p>
            </span>
            <p className="step-title">Mejora en la toma de decisiones</p>
            <p className="step-subtitle">
              Toma decisiones más inteligentes y estratégicas basadas en datos
              concretos.
            </p>

            <ul>
              <li>Acceso a información precisa, confiable y actualizada.</li>
              <li>
                Mejora la forma en que se comunican los datos, mediante informes
                visuales y presentaciones dinámicas.
              </li>
              <li>Mayor confianza en las decisiones estratégicas.</li>
              <li>Reducción de riesgos y margen de error.</li>
            </ul>
          </div>
        </div>
        <div className="columna">
          <img
            alt="step-1"
            src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/step-1.png`}
          />
        </div>
      </section>
      {/* OPTIMIZA */}
      <div
        style={{
          //   background: `url( no-repeat center center`,
          //   backgroundSize: "80%",
          position: "relative",
        }}
        // style={}
      >
        <img
          src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/fondo2.png`}
          alt="fondo2"
          style={{}}
          id="fondo2"
        />
        <section
          className="light-section"
          style={{ position: "relative", zIndex: 1, margin: "5rem 0" }}
        >
          <div className="columna">
            <img
              alt="step-1"
              src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/step-2.png`}
            />
          </div>
          <div className="columna">
            <div
              className="bi-step-content"
              style={{ marginLeft: "auto", color: "white" }}
            >
              <span className="bi-header">
                <img
                  //   style={{ width: "20%" }}
                  alt="numero-2"
                  src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/numeros-2.png`}
                />
                <p>Optimiza</p>
              </span>
              <p className="step-title">
                Optimiza tu Cash flow y toma el control de tus finanzas
              </p>
              <p className="step-subtitle">
                La optimización de los procesos financieros se traduce en tener
                una empresa más eficiente y rentable.
                <br />
                Automatiza las tareas repetitivas que abundan en la recopilación
                y registro de datos, así como en la conformación y actualizacíon
                de presentaciones.
                <br />
                Disminuye drásticamente las tareas manuales, liberando tiempo
                para tareas más relevantes, reduciendo el error humano.
              </p>
            </div>
          </div>
        </section>
      </div>
      {/* ANTICIPA */}
      <section className="light-section">
        <div className="columna">
          <img
            alt="step-3"
            src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/step-3.png`}
          />
        </div>
        <div className="columna">
          <div className="bi-step-content" style={{ marginLeft: "auto" }}>
            <span className="bi-header">
              <img
                //   style={{ width: "20%" }}
                alt="numero-3"
                src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/numeros-3.png`}
              />
              <p>Anticipa</p>
            </span>
            <p className="step-title">Anticipa las tendencias del mercado</p>
            <p className="step-subtitle">
              Mayor competitividad al anticipar las tendencias del mercado y
              adaptar las estrategias en consecuencia.
            </p>

            <ul>
              <li>Identificación de nuevas oportunidades de mercado.</li>
              <li>Desarrollo de nuevos productos y servicios.</li>
              <li>Expansión geográfica.</li>
            </ul>
          </div>
        </div>
      </section>
      {/* AUMENTA */}
      <section className="light-section">
        <div className="columna">
          <div className="bi-step-content">
            <span className="bi-header">
              <img
                //   style={{ width: "20%" }}
                alt="numero-4"
                src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/numeros-4.png`}
              />
              <p>Aumenta</p>
            </span>
            <p className="step-title">
              Aumento de la eficiencia en todas las áreas
            </p>
            <p className="step-subtitle">
              Automatiza tus procesos y reduce costos al identificar áreas de
              mejora. Utiliza datos históricos y análisis predictivos para
              planificar y crear escenarios.
            </p>

            <ul>
              <li>Niveles de gastos y volumenes de ingresos.</li>
              <li>Flujos financieros.</li>
              <li>Control de gestión.</li>
              <li>Balance financiero por centro de costos.</li>
            </ul>
          </div>
        </div>
        <div className="columna">
          <img
            alt="step-4"
            src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/step-4.png`}
          />
        </div>
      </section>
      {/* CRECE */}
      <div
        style={{
          position: "relative",
          overflow: "hidden",
        }}
      >
        <img
          alt="fondo-bajo"
          style={{
            width: "100%",
            position: "absolute",
            // bottom: "calc(-25%)",
            right: 0,
            zIndex: 0,
          }}
          src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/fondo3.png`}
          id="fondo5"
        />
        <section
          className="light-section"
          style={{ position: "relative", zIndex: 1 }}
        >
          <div className="columna">
            <img
              alt="step-5"
              src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/step-5.png`}
            />
          </div>
          <div className="columna">
            <div
              className="bi-step-content"
              style={{ marginLeft: "auto", color: "white" }}
            >
              <span className="bi-header">
                <img
                  //   style={{ width: "20%" }}
                  alt="numero-5"
                  src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/numeros-5.png`}
                />
                <p>Crece</p>
              </span>
              <p className="step-title">Crecimiento del negocio</p>
              <p className="step-subtitle">
                Maximiza tus ganancias y alcanza tus objetivos comerciales.
              </p>

              <ul>
                <li>Aumento de los márgenes de beneficio.</li>
                <li>
                  Mayor retorno de la inversión (ROI) en marketing y ventas.
                </li>
              </ul>
            </div>
          </div>
        </section>

        <div
          className="meet-wrapper"
          style={{
            // marginBlock: "2rem",
            // background:
            //   "linear-gradient(to bottom, var(--blue-background), var(--blue-background) 50%), #FFF 50%, #FFF 100%",

            background:
              "linear-gradient(transparent 0%,transparent 50%, #fff 50%,#fff 100%)",
          }}
        >
          <div
            className="meet-box"
            style={{
              backgroundColor: "var(--red-highlight)",
              color: "white",
            }}
            id="business"
          >
            <p className="meet-title">
              ¿Sabes realmente cómo están tus ventas?
            </p>
            <p className="color-card-subtitle">
              Te acompañamos en todo el proceso de implementación y te brindamos
              soporte continuo para que puedas aprovechar al máximo tu solución
              de BI.
            </p>
            <span className="horizontal gap-16">
              <WhatsappLink>
                <button
                  className="boton-generico boton-rojo"
                  style={{ borderColor: "white" }}
                >
                  <p>Más info</p>
                  <FaArrowRight />
                </button>
              </WhatsappLink>
              <button
                className="boton-generico boton-rojo"
                style={{ borderColor: "white" }}
                onClick={() => navigateAndScroll("/demo", "top")}
              >
                <p>Solicitar demo</p>
                <FaArrowRight />
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BiSteps;
